import React from "react";
import { FaCalendarAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { Card } from "reactstrap";
import { useRecoilValue } from "recoil";
import { adminProfileState } from "src/atoms/profile.atoms";
import { CONSTANTS } from "src/constants";
import { COMMON_CONSTANTS } from "src/constants/commonConstants";
import { URL_CONSTANTS } from "src/constants/url.constants";
import { useUrls } from "src/hooks/useUrls";
import { commonLocales } from "src/locales/commonLocales";
import {
  NotificationProps,
  ObjectProps,
  ProfileProps,
} from "src/models/common.model";
import { DrawerProps } from "src/models/layout.models";
import { getData, readNotifications } from "src/utils/notification.utils";

const DrawerComponent: React.FC<DrawerProps> = ({
  notifications,
  open,
  setOpen,
  setNotifications,
}) => {
  const navigation = useNavigate();
  const { allowedUrls } = useUrls();

  const profile = useRecoilValue<ProfileProps>(adminProfileState);

  const openDrawer = () => {
    setOpen(!open);
  };
  return (
    <div className="dd-right-drawer shadow">
      <div className="dd-drawer-header d-flex align-items-center justify-content-between p-3 fw-bold">
        {commonLocales.alerts}

        <div className="d-flex align-items-center">
          <button
            className="border-0 me-3 rounded-pill px-2"
            onClick={() => {
              setOpen(!open);
              navigation(URL_CONSTANTS.NOTIFICATION);
            }}
          >
            {commonLocales.viewAll}
          </button>
          <button
            className="btn-close btn-close-white p-2 rounded"
            onClick={() => {
              openDrawer();
            }}
          ></button>
        </div>
      </div>
      <div className="dd-drawer-content">
        {(notifications as NotificationProps[])
          .filter((notification: NotificationProps) => !notification.is_read)
          .slice(CONSTANTS.INITIAL_VALUE, CONSTANTS.FIRST_TEN_ITEM)
          .map((notification: NotificationProps, index: number) => {
            return (
              <Card
                className={`dd-notification-card pt-2 pb-0  rounded-0 border-top border-light ${notification.is_read ? "dd-notification-read-true" : "dd-notification-read-false"}`}
                key={`${(notification?.uuid as string) ?? ""} ${index}`}
                onClick={() => {
                  setOpen(!open);
                  readNotifications(
                    notifications as NotificationProps[],
                    (notification as ObjectProps)?.uuid as string,
                    setNotifications,
                    navigation,
                    allowedUrls,
                    Number(profile?.type) ?? 0
                  );
                }}
              >
                <div className={"w-100 notification-text dd-notification-text"}>
                  <p className="notification-text txt-fs-1 fw-normal gray ms-2 px-2">
                    <div>
                      <span className="fw-semibold pe-1">
                        {
                          getData(
                            notification,
                            COMMON_CONSTANTS.TITLE
                          ) as string
                        }
                      </span>
                      {"   "}
                      <span>
                        {
                          getData(
                            notification,
                            COMMON_CONSTANTS.CONTENT
                          ) as string
                        }
                      </span>
                    </div>
                    <div className="d-flex align-items-center date-text">
                      {" "}
                      {!(
                        getData(notification, COMMON_CONSTANTS.DATE) as string
                      )?.includes(COMMON_CONSTANTS.TODAY) && (
                        <FaCalendarAlt className="me-1 dd-notification-date-icon" />
                      )}
                      {getData(notification, COMMON_CONSTANTS.DATE) as string}
                    </div>
                  </p>
                </div>
              </Card>
            );
          })}
      </div>
    </div>
  );
};

export default DrawerComponent;
